import { observer } from 'mobx-react-lite'
import { DateRangeFilterView } from '@/components/FilterControls/DateRange'
import { type DateRangeFilter } from '@/infra/DateRangeFilter'

interface DateRangeFilterViewContainerProps<
  TFilters extends Record<string, unknown>,
> {
  filter: DateRangeFilter<keyof TFilters>
  testId?: string
}

/**
 * Editor for a {@link DateRangeFilter}.
 */
export const DateRangeFilterViewContainer = observer(
  function DateRangeFilterViewContainer<
    TFilters extends Record<string, unknown>,
  >({ filter, testId }: DateRangeFilterViewContainerProps<TFilters>) {
    return (
      <DateRangeFilterView
        title={filter.title}
        from={filter.value?.from ?? undefined}
        to={filter.value?.to ?? undefined}
        onFromChange={filter.setFrom}
        onToChange={filter.setTo}
        testId={testId}
        onClear={filter.clear}
      />
    )
  },
)
